export default {
    props: {
        pasteCleanupAll: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.all'
        }, 
        pasteCleanupCss: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.css'
        }, 
        pasteCleanupCustom: {
            type: Function,
            default: undefined,
            kComposite: 'pasteCleanup.custom'
        }, 
        pasteCleanupKeepNewLines: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.keepNewLines'
        }, 
        pasteCleanupMsAllFormatting: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.msAllFormatting'
        }, 
        pasteCleanupMsConvertLists: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.msConvertLists'
        }, 
        pasteCleanupMsTags: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.msTags'
        }, 
        pasteCleanupNone: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.none'
        }, 
        pasteCleanupSpan: {
            type: Boolean,
            default: undefined,
            kComposite: 'pasteCleanup.span'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditor/PasteCleanup.js